/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable sonarjs/no-duplicate-string */
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AnalyticsService,
  AnalyticsTransforms,
  FeatureAnalyticsService,
  RuleSet,
} from '@cigna/shared/angular/analytics-data-access';

interface CFBRules extends RuleSet {}

@Injectable({
  providedIn: 'root',
})
export class CFBAnalyticsService extends FeatureAnalyticsService<CFBRules> {
  protected transforms: AnalyticsTransforms<CFBRules> = {};

  constructor(analytics: AnalyticsService) {
    super(analytics);
  }
}
